/* eslint-disable @next/next/no-img-element */
import { CDN2 } from '@/helpers/api';
import React from 'react';

export interface ILowestPriceGuarantee {
  isCardList?: boolean;
}

function LowestPriceGuarantee({ isCardList }: ILowestPriceGuarantee) {
  return (
    <div
      className={`flex flex-col h-auto border rounded-md bg-[#069B27]/10 ${isCardList ? 'w-[13rem] md:w-11/12 p-1' : 'w-full md:w-44 p-1 '
        }`}
    >
      <div
        className={`flex flex-row text-center px-2 md:px-2 ${isCardList ? 'justify-start' : 'justify-center'
          }`}
      >
        <img
          src={CDN2() + '/staticmyapp/lpguarantee.svg'}
          className="z-0 object-cover w-4 md:w-5 h-5 md:h-6"
          alt="image"
        />
        <p
          className={`text-xs font-bold self-center whitespace-nowrap ${isCardList ? 'md:text-xs' : 'md:text-[0.688rem]'
            }`}
        >
          Lowest Price Guarantee *
        </p>
      </div>
    </div>
  );
}

export default LowestPriceGuarantee;
